import styled from '@emotion/styled';
import { Box } from '@mui/material';
import { primaryPalette } from '../../theme';

interface ShareContainerProps {
  isMobile?: boolean;
}

export const ShareContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== "isMobile",
}) <ShareContainerProps>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: ${primaryPalette[500]};
  padding: ${({ isMobile }) => (isMobile ? "16px 8px 16px" : "16px")};
`

export const ShareButtonsContainer = styled(Box)`
  flex-shrink: 0;
  padding-left: "4px";
`
